import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export function RecycleBinIcon(props: any) {
    return (
        <SvgIcon {...props} viewBox="0 0 64 64">
            <path
                d="M16.0002 50.6667C16.0002 53.6 18.4002 56 21.3335 56H42.6668C45.6002 56 48.0002 53.6 48.0002 50.6667V18.6667H16.0002V50.6667ZM50.6668 10.6667H41.3335L38.6668 8H25.3335L22.6668 10.6667H13.3335V16H50.6668V10.6667Z"
                fill="#6B7985"
            />
            <path
                d="M25.77 32.15L27.2 29.78L28.23 28.07C28.62 27.42 29.56 27.42 29.95 28.07L31.43 30.53L30.2 32.59L29.2 34.21L25.77 32.15ZM41.72 37.97L40.12 35.31L36.66 37.31L38.87 41H40C40.76 41 41.45 40.57 41.79 39.89C41.93 39.61 42 39.31 42 39C42 38.64 41.9 38.29 41.72 37.97ZM36 46H37.5C38.26 46 38.95 45.57 39.29 44.89L40.74 42H36V40L32 44L36 48V46ZM30 42H25.7L24.86 43.41C24.56 43.91 24.54 44.53 24.8 45.06C25.08 45.63 25.67 46 26.32 46H30V42ZM26.12 39.35L27.85 40.39L26.48 34.9L21 36.27L22.7 37.29L22.29 37.98C21.94 38.57 21.91 39.29 22.22 39.9L23.85 43.16L26.12 39.35ZM37.02 30.14L35.72 27.97C35.35 27.37 34.7 27 34 27H30.47L33.59 32.2L31.87 33.23L37.36 34.6L38.73 29.11L37.02 30.14Z"
                fill="white"
            />
        </SvgIcon>
    );
}
